import { defineComponent as _defineComponent } from 'vue'
import { ImageV1 } from '@ilteducation/content-registry-types';
import { computed, ref } from 'vue';
import store from '@/store';
import TranslationsTable from '@/components/base/TranslationsTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAltText',
  props: {
    item: null,
    previewImage: null,
    forceTranslatable: { type: Boolean },
    showButtons: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  item: ImageV1;
  previewImage?: any;
  forceTranslatable?: boolean;
  showButtons?: boolean;
}



const altText = ref(props.item.altText);
const language = ref(props.item.language);
const translate = ref(props.forceTranslatable || (!!props.item.altText && !!props.item.language));
const loading = ref(false);
const showError = ref<{ [field: string]: string[] }>({});
const translationTable = ref<InstanceType<typeof TranslationsTable> | null>(null);

const altTextChanged = computed(() => {
  return altText.value && altText.value !== props.item.altText;
});
const languageChanged = computed(() => {
  return language.value !== props.item.language;
});

const isChanged = computed(() => {
  return (altText.value && altText.value !== props.item.altText) || language.value !== props.item.language;
});
const errorMessages = computed(() => {
  const messages: { [field: string]: string[] } = { altText: [], language: [] };
  if (!altText.value && !language.value && !translate.value) {
    return messages;
  }
  if (!altText.value) {
    messages.altText.push('Alt text is required.');
  }
  if (!language.value) {
    messages.language.push('Language is required.');
  }
  return messages;
});
const valid = computed(() => {
  return !translate.value || (language.value && altText.value);
});

const saveAltText = (overrideId?: string) => {
  if (translate.value && (!isChanged.value || !valid.value)) {
    displayError();
    return;
  }

  if (!altTextChanged.value && !languageChanged.value) {
    return; // No changes to save
  }
  loading.value = true;

  const data = [];
  if (altTextChanged.value) {
    data.push({ op: 'replace', path: '/altText', value: altText.value });
  }
  if (translate.value) {
    data.push({ op: 'replace', path: '/language', value: language.value });
  } else if (props.item.language !== undefined) {
    // If translation is not enabled, we remove the language field
    data.push({ op: 'replace', path: '/language', value: undefined });
  }

  store
    .dispatch('content-image/update', {
      id: overrideId || props.item.id,
      data,
    })
    .then(() => {
      loading.value = false;
    });
};

const displayError = () => {
  showError.value = errorMessages.value;
  setTimeout(() => {
    showError.value = {};
  }, 2000);
};

expose({
  saveAltText,
});

return { __sfc: true,props, altText, language, translate, loading, showError, translationTable, altTextChanged, languageChanged, isChanged, errorMessages, valid, saveAltText, displayError, TranslationsTable }
}

})